module.exports = __webpack_public_path__ + "static/img/loginlogo.fb31b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/loginlogo.png
// module id = T9vV
// module chunks = 0